module.exports = __webpack_public_path__ + "img/woman-with-contactlenses.23040f4a.png";